<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['guessProvince']
      }"
      @click="
        configMainShow['guessProvince'] = !configMainShow['guessProvince']
      "
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>猜省会</span>
        <span
          class="el-switch"
          @click.stop="toggleEnable('guessProvince', '猜省会')"
        >
          <el-switch
            v-model="configure.guessProvince.enable"
            disabled
          ></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['guessProvince'].timeRemaining)
          ? shoWDialogBuy(
              featureList['guessProvince']['productKey'],
              '猜省会',
              'guessProvince'
            )
          : featureList['guessProvince'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.guessProvince.enable
          ? ''
          : toggleEnable('guessProvince', '猜省会')
      "
      :class="{
        'no-buy': isNaN(featureList['guessProvince'].timeRemaining),
        expired: featureList['guessProvince'].timeRemaining <= 0,
        'shut-off': !configure.guessProvince.enable
      }"
    >
      <el-row>
        <el-col :span="5">游戏配置</el-col>
        <el-col :span="19">
          <div class="block-tag">
            <p>
              游戏开启：<span class="yellow">主播或房管</span> 发送弹幕
              <span class="green">@猜省会</span> 方可开启游戏。
            </p>
            <p>
              立刻开始：发送弹幕
              <span class="green">@开始游戏</span> 可立刻开始游戏。
            </p>
            <p>
              立刻结束：发送弹幕
              <span class="green">@结束游戏</span> 可立刻结束游戏。
            </p>
          </div>
          <q>
            猜省会是一款弹幕小游戏，机器人作为裁判，从全国选一个省会不告诉大家，报名的用户才能参与游戏，每回合每人限猜一次，机器人会说：目标在你所猜城市的左边还是右边，上边还是下边。通过这个信息大家可以缩小范围，最终猜到答案的获胜。
          </q>
          <el-row>
            <el-col :span="5">报名礼物</el-col>
            <el-col :span="19">
              <el-select
                v-model="configure.guessProvince.joinGiftName"
                size="mini"
                placeholder="请选择"
              >
                <el-option-group
                  v-for="(group, i) in guessGameGiftOptions"
                  :key="i"
                  :label="group.label"
                >
                  <el-option
                    v-for="(groupitem, index) in group.options"
                    :key="index"
                    :label="groupitem.label"
                    :value="groupitem.value"
                  ></el-option>
                </el-option-group>
              </el-select>
              <el-input-number
                v-model="configure.guessProvince.joinGiftCount"
                :controls-position="isPC ? 'right' : ''"
                :min="0"
                size="mini"
              ></el-input-number
              >个
              <div class="row-padding">
                <el-switch
                  v-model="configure.guessProvince.isEqualPrice"
                  style="margin-left:5px"
                ></el-switch
                >接受其他礼物自动折算
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">报名时间</el-col>
            <el-col :span="19">
              <el-input-number
                v-model="configure.guessProvince.registTime"
                :controls-position="isPC ? 'right' : ''"
                :min="0"
                size="mini"
                :precision="1"
              ></el-input-number>
              分钟
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">参与人数</el-col>
            <el-col :span="19">
              <el-input-number
                v-model="configure.guessProvince.personCount"
                :controls-position="isPC ? 'right' : ''"
                :min="1"
                :max="20"
                size="mini"
              ></el-input-number>
              人
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">回合时间</el-col>
            <el-col :span="19">
              <el-input-number
                v-model="configure.guessProvince.turnTime"
                :controls-position="isPC ? 'right' : ''"
                :min="0"
                size="mini"
                :precision="1"
              ></el-input-number>
              分钟
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">回合限制</el-col>
            <el-col :span="19">
              <el-input-number
                v-model="configure.guessProvince.turnLimit"
                :controls-position="isPC ? 'right' : ''"
                :min="0"
                size="mini"
              ></el-input-number>
              回合
              <q
                >回合内无人猜出则游戏结束，算挑战失败。0表示不限回合，直至猜出。</q
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('猜省会', 'guessProvince')"
          >「猜省会」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { configCommon } from '@/mixins/configCommon'
import { commonFuc } from '@/mixins/commonFuc'
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {}
  },
  props: {
    configure: {
      type: Object,
      default: null
    },
    featureList: {
      type: Object,
      default: null
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessProvince: true,
          duty: true,
          global: true
        }
      }
    },
    guessGameGiftOptions: {
      type: Array,
      default: require('@/assets/js/guessGameGiftOptions.json')
    }
  },
  mounted() {},
  methods: {}
}
</script>
